// extracted by mini-css-extract-plugin
export default {"overlay":"ConfluenceModal_overlay__r+1-U","modal":"ConfluenceModal_modal__UGR+c"};